export enum JumbotronVariantEnum {
  Default = 'default',
  FullWidthImage = 'full-width-image',
  Rounded = 'rounded',
  WithoutPicture = 'without-picture',
}
